Apt.fn.make('loan', {
	/**
	 * Initialize module
	 */
	init() {
		const scope = this;

		LS.util.load('payment', () => {
			scope.payment = Apt.fn.payment()
				.init('$calculator', {
					term: 180,
					down: 25,
					price: 50000,
					max: 500000,
					tax: 300
				});
		});

		scope.meta = Apt.fn.meta()
			.init();
	},

	/**
	 * Unload module
	 */
	unload() {
		LS.util.reset('loan', this, [
			'meta',
			'payment'
		]);
	}
});